export const notificationConfigs = {
    initNotificationsRows: 5,
    initNotificationsPage: 1,
}